import axios from 'axios';
import { AxiosError } from 'axios';
import { API_GATEWAY_BASE_URL } from '@/core/global-data/constants.data';
import { clearAuthTokens } from '@/features/auth/guard/utils';
import router from '@/core/global-router';
import { toast } from 'sonner';

const defaultURL = API_GATEWAY_BASE_URL;
axios.defaults.baseURL = defaultURL;

const handleUnauthorized = () => {
    clearAuthTokens();
    router.navigate('/login');
    window.location.reload();
};

axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        const status = error.response?.status;
        const isUnauthorized = status === 401;
        if (isUnauthorized && !error.config?.url?.includes('/login')) {
            handleUnauthorized();
        }
        if (
            status === 403 &&
            error.response?.data &&
            typeof error.response.data === 'object' &&
            'message' in error.response.data
        ) {
            toast.error((error.response.data as { message?: string }).message);
        }
        return Promise.reject(error);
    },
);

export const endpoints = {
    auth: {
        login: '/login',
        me: '/me',
        changePassword: '/change-password',
        forgotPassword: '/forgot-password',
        resetPassword: '/reset-password',
    },
    bookings: {
        list: '/booking-list-pagination',
        create: '/booking-create',
        show: '/booking-show/',
        update: '/booking-update/',
        delete: '/booking-delete/',
        stats: '/booking-list-by-status',
        analytics: '/booking-analytics',
        select: '/booking-list-select',
    },


    // ------------------------------
    finance: {
        payments: '/doctors-clinics-finance-payments',
        stats: '/doctors-clinics-finance-stats',
    },
    reports: {
        stats: '/doctors-clinics-reports-stats',
    },
    patient: {
        create: '/clinic-patients-store',
        update: '/clinic-patients-update/',
        delete: '/clinic-patients-delete/',
        list: '/clinic-patients-paginated',
        select: '/clinic-patients-simple',
        show: '/clinic-patients-show/',
        block: '/clinic-patients-add-to-black-list/',
        dashboard: '/clinic-patients-analytics',
        all: '/clinic-patients-checkup-all/',
        details: '/patients/',
    },

    rumors:{
        list: '/patients/{patient}/rumors',
        create: '/patients/{patient}/rumors',
        update: '/patient-rumors/{rumor}',
        delete: '/patient-rumors/{rumor}',
    },
    settings: {
        settings: '/settings',
    },
};
